import { useTimeBasedAuthenticationConfigurationCreateCommand } from '@dreryk/egabinet-security-frontend';
import { PromiseVoidFunction } from '@dreryk/react-common';
import { Button, ButtonVariant, dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import { mfaSettingsTranslationKeys } from '../../../../translations';

import { CreateAssociationVerificationCodeFormController } from './CreateAssociationVerificationCodeForm.types';

type CreateAssociationButtonProps = {
   readonly handleSubmit: CreateAssociationVerificationCodeFormController['handleSubmit'];
   readonly secret: string;
   readonly onSuccess: PromiseVoidFunction;
};

export const CreateAssociationButton = (props: CreateAssociationButtonProps): JSX.Element => {
   const {
      executeAsync: createTimeBasedAuthenticationConfiguration,
   } = useTimeBasedAuthenticationConfigurationCreateCommand(async () => {
      await props.onSuccess();
      dispatchSnackbarPositiveEvent(mfaSettingsTranslationKeys.mfaHasBeenActivated);
   });

   return (
      <Button
         testId={'createMfaAssociation'}
         label={mfaSettingsTranslationKeys.associate}
         onClick={props.handleSubmit(async (values) =>
            createTimeBasedAuthenticationConfiguration({
               verificationCode: values.verificationCode!,
               secret: props.secret,
            })
         )}
         variant={ButtonVariant.PRIMARY}
      />
   );
};
